import { useEffect } from "react";
import { ListingEditModalHeader } from "./ListingEditModalHeader";
import { ListingEditModalFormWrapper } from "./ListingEditModalFormWrapper";

const ListingEditModal = ({
  selectedListingId,
  setSelectedListingId,
  setOpenEditListing,
  openEditListing,
  listing,
  getListing,
  exceptions,
  getExceptions
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-700px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <ListingEditModalHeader
              setSelectedListingId={setSelectedListingId}
              setOpenEditListing={setOpenEditListing}
              listing={listing}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <ListingEditModalFormWrapper
                selectedListingId={selectedListingId}
                setSelectedListingId={setSelectedListingId}
                openEditListing={openEditListing}
                setOpenEditListing={setOpenEditListing}
                listing={listing}
                getListing={getListing}
                exceptions={exceptions}
                getExceptions={getExceptions}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { ListingEditModal };
